module.exports = __webpack_public_path__ + "static/media/Prof LIN.2d4e6aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Prof LIN.jpg
// module id = 177
// module chunks = 0